import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import AOS from "aos";
import "aos/dist/aos.css";

import overlay from "../assets/overlay.jpg";
import aziz from "../assets/aziz.jpg";
import george from "../assets/george.jpg";
import nicolas from "../assets/nicolas.jpg";
import elias from "../assets/elias.jpg";
import hussein from "../assets/hussein.jpg";
import gerald from "../assets/gerald.jpg";

export default function Staff() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  const leadershipTeam = [
    {
      id: "aziz",
      name: "Aziz M. Kilonge",
      title: "Group Chairman",
      image: aziz,
      bio: (
        <>
          <p>
            Aziz M. Kilonge is a Procurement and Supply Chain professional with more than
            38 years of experience. His work covers procurement planning, reviews,
            strategies, procedures, contract management, auditing, documentation, and
            the development of manuals, handbooks, and training guides. He also trains
            teams in procurement, supply chain, management, and leadership.
          </p>

          <p>
            He has worked with World Bank projects, USAID Tanzania, TANESCO, DANIDA,
            TASAF and several local and international clients. His experience includes
            the application of World Bank Guidelines, US Federal Acquisition and
            Assistance Regulations, USAID’s AIDAR, the Tanzania Public Procurement Act,
            and the Zanzibar Public Procurement and Disposal of Public Assets Act.
          </p>

          <p>
            He has taken part in mid-term reviews, implementation completion reports,
            post-procurement audits, and capacity-building assignments. He has supported
            community projects and institutions financed by international development
            partners and created practical tools used across organisations.
          </p>

          <p>
            He has served on the boards of PSPTB and the Tanzania Ports Authority. He is
            a Certified Director of the Tanzania Institute of Directors and applies
            corporate governance principles in his work. He continues to advise public
            and private organisations on procurement, supply chain, contract management,
            organisational development, change management, and leadership.
          </p>
        </>
      )
    },

    {
      id: "george",
      name: "George R. Mziray",
      title: "Senior Consultant",
      image: george,
      bio: (
        <>
          <p>
            Mr. George R. Mziray has over 38 years of progressive experience in social
            development consulting across Africa. He has participated in numerous
            qualitative and quantitative socio-economic studies and activities related
            to agriculture, finance, and health sectors.
          </p>

          <p>
            His work covers surveys, market research, evaluations, situational analysis,
            participatory planning, monitoring and evaluation, feasibility studies,
            product development, project planning, rural financing, financial inclusion,
            institutional analysis, and market scoping. His focus areas include
            smallholder farmers and gender.
          </p>

          <p>
            He has worked across Tanzania and in Kenya, Zambia, Ethiopia, Rwanda,
            Burundi, and Malawi, but has also managed and coordinated evaluation
            activities in Burkina Faso, Ghana, Mali, Mozambique, and Uganda.
          </p>

          <p>
            George has led assignments for international donors and institutions such as
            AGRA, USAID, Heifer International, CARE, Rikolto, RTI International, the World
            Bank, and Government Institutions such as the National Bureau of Statistics
            (NBS) and the Tanzania Public Service College (TPSC). He is proficient in
            quantitative and qualitative research methods, data quality assurance (DQA),
            and Results-Based Management (RBM).
          </p>

          <p>
            He has completed specialised training on Impact evaluation (World Bank,
            Kenya); Project planning and management (MS-TCDC); Local economic Development
            on linking small scale producers to modern markets and agro-food market
            Development at CIAT (South Africa); Project planning, monitoring and
            evaluation (UDBS); Participatory Planning, Monitoring and Evaluating
            (Wageningen University, Netherlands); Rural Micro Financing (Wageningen
            University, Netherlands), naming a few.
          </p>

          <p>
            George holds a Postgraduate Diploma in Poverty Analysis from the Institute of
            Social Studies - The Hague, MSc in Policy Studies and Analysis from the
            University of Zimbabwe, and a BA in Economics from the University of Dar es
            Salaam.
          </p>
        </>
      )
    },

    {
      id: "nicolas",
      name: "Nicolas O. Suke",
      title: "Group Secretary",
      image: nicolas,
      bio: (
        <>
          <p>
            Professionally, Nicolas Oyuaya Suke is a Certified Supply Chain
            Professional-CSP(T) from the Procurement and Supplies Professionals and
            Technicians Board (PSPTB), Masters of Business Administration (MBA) from the
            University of Dar es Salaam, Tanzania and an Advanced Diploma in Materials
            Management from the University of Mzumbe, Tanzania. He attended several
            Executive Management Development Programmes in South Africa, including
            Stellenbosch University.
          </p>

          <p>
            He has over 41 years of extensive experience in Procurement and Supply Chain
            Management and has trained several teams from various Public and Private
            institutions.
          </p>

          <p>
            Suke has worked in various sectors ranging from Clearing & Forwarding,
            Banking and Energy (Electricity), where he worked as Stores in charge, Credit
            Supervisor, Head of Supply & Transport and Head of Procurement Management
            Unit, where, as a result of successful performance, he rose from junior
            positions to senior status.
          </p>

          <p>
            Suke is a Senior Procurement Consultant and one of the Facilitators and
            Resource persons in various trainings conducted by the Procurement and
            Supplies Professionals and Technicians Board (PSPTB), Tanzania. In summary,
            Suke is a Strategic and a Team player.
          </p>
        </>
      )
    },

    {
      id: "elias",
      name: "Elias L. Samwel",
      title: "Senior Logistics & Supply Chain Specialist",
      image: elias,
      bio: (
        <>
          <p>
            Elias Lameck Samwel is an experienced Logistics Manager with a strong
            international background in logistics, finance, and supply chain management.
            He brings over fifteen years of professional experience gained at Philips
            Middle East and Africa, based in Dubai, UAE.
          </p>

          <p>
            During his tenure at Philips, he held several senior roles, including Senior
            Logistics Officer, where he coordinated warehouse operations, managed
            customer service delivery, and resolved logistics issues such as damaged or
            incorrect deliveries.
          </p>

          <p>
            He later served as Logistics Manager, leading a regional supply chain team
            responsible for healthcare equipment orders across the Middle East. In this
            role, he drove supply chain improvement initiatives, collaborated with
            suppliers in the USA and the Netherlands, ensured compliance with quality
            systems and export control regulations, and supported people and performance
            management.
          </p>

          <p>
            Earlier in his career, he worked as the Project Logistics Controller for
            Philips Medical, managing logistics for the Tanzanian Government’s ORET
            Project, which focused on rehabilitating hospital diagnostic services.
          </p>

          <p>
            Samwel holds an MBA in Finance and Accounting from Preston University (2008)
            and has continued his professional development with certifications in Trade
            and Logistics from Dubai Trade (DP World subsidiary). He has a rich
            educational background, including a BBA in Materials Management (ADMM) from
            Mzumbe University, a Post Graduate Diploma in Managerial Control & Management
            Information System (PGD-MC&MIS) from Maastricht School of Management (The
            Netherlands), as well as Certification in Supplies Professional (CSP) from
            the National Board for Materials Management (NBMM).
          </p>
        </>
      )
    },

    {
      id: "hussein",
      name: "Hussein M. Njovu",
      title: "Group Accountant",
      image: hussein,
      bio: (
        <>
          <p>
            Hussein. Njovu is an Accountant with over 40 years of experience in the
            accounting field and financial management. As an accountant, he gained
            extensive experience in conducting expenditure management assignments for
            both central and local government authorities in Tanzania and for business
            enterprises beyond its borders.
          </p>

          <p>
            His areas of expertise cover the preparation of annual budgets, planning and
            project budgets, supervising and maintaining finances for foreign
            government-funded projects, maintaining compliance with statutory
            authorities, preparing accounts for audit, preparing quarterly financial
            reports for board meetings, and supervising organisational expenditure.
          </p>

          <p>
            Njovu is well-versed in conducting feasibility studies for new projects,
            managing finance and administration, including developing grassroots
            projects for financing, training grantees in financial management,
            monitoring and evaluation of projects, project activity and financial
            reporting, project remediation, and project closeouts.
          </p>

          <p>
            He managed investment funds, associated risks, cash management,
            capital-raising strategies to support the firm’s expansion, and mergers and
            acquisitions.
          </p>

          <p>
            He was able to determine, compile, and prepare monthly/quarterly forecasts
            and year-end expected results. He analysed the financial results of current
            operations, explained variances, prepared reforecasts, and prepared,
            managed, and implemented standard and ad hoc financial/operational reports.
          </p>

          <p>
            Njovu is currently retired.
          </p>
        </>
      )
    },

    {
      id: "gerald",
      name: "Gerald S. Msovela",
      title: "Group Legal Counsel",
      image: gerald,
      bio: (
        <>
          <p>
            Gerald is a trained lawyer and an Advocate of the High Court of Tanzania and
            its subordinate courts, registered with the Tanganyika Law Society under
            Registration No. 3114. He has professional experience in civil litigation,
            criminal matters, mediation, and labour-related issues.
          </p>

          <p>
            Before qualifying as a lawyer, he worked for fifteen years with the Ministry
            of Defense and National Service as a civilian storekeeper, following the
            completion of a Diploma in Materials Management from the College of Business
            Education.
          </p>

          <p>
            He later joined TAZARA in 1988, where he served for twenty-nine years.
            Following his LLB, he was promoted to senior management at TAZARA and served
            as Senior Legal Counsel until his retirement in 2017.
          </p>

          <p>
            He has also served on national committees and currently sits on a secondary
            school board.
          </p>
        </>
      )
    }
  ];

  useEffect(() => {
    setReady(true);
    AOS.init({ duration: 1000, easing: "ease-in-out" });
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div
      className="MainBodySection"
      style={{
        paddingTop: "50px",
        paddingBottom: "50px",
        backgroundImage: `url(${overlay})`,
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundPosition: "center"
      }}
    >
      <div className="container my-5">
        <h3 className="main-section-title text-center mb-5">
          GROUP MANAGEMENT TEAM
        </h3>

        <div className="accordion" id="teamAccordion">
          {leadershipTeam.map((member) => (
            <div key={member.id} className="accordion-item mb-3 shadow-sm">
              <h2 className="accordion-header">
                <button
                  className="accordion-button collapsed d-flex gap-3"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${member.id}`}
                >
                  <img
                    src={member.image}
                    alt={member.name}
                    width="60"
                    height="80"
                    className="rounded object-fit-cover"
                  />
                  <div className="text-start">
                    <strong>{member.name}</strong>
                    <div className="text-muted small">
                      {member.title}
                    </div>
                  </div>
                </button>
              </h2>

              <div
                id={member.id}
                className="accordion-collapse collapse"
                data-bs-parent="#teamAccordion"
              >
                <div className="accordion-body">
                  {member.bio}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
